// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("@rescript/std/lib/js/curry.js");
var React = require("react");
var Context = require("./Context.bs.js");
var Util_I18n = require("../util/Util_I18n.bs.js");
var Context_I18n = require("./Context_I18n.bs.js");

function initialState(locale, labels, formaters, myArteUrl, loginUrl, profileUrl) {
  return {
          formaters: formaters,
          labels: labels,
          locale: locale,
          myArteUrl: myArteUrl,
          loginUrl: loginUrl,
          profileUrl: profileUrl
        };
}

function myArteUrlWithLocale(baseUrl, locale) {
  return "" + baseUrl + "?lang=" + locale + "";
}

function reducer(myArteBaseUrl, state, action) {
  var variant = action.NAME;
  if (variant === "ChangeLocale") {
    return {
            formaters: state.formaters,
            labels: state.labels,
            locale: action.VAL,
            myArteUrl: state.myArteUrl,
            loginUrl: state.loginUrl,
            profileUrl: state.profileUrl
          };
  }
  if (variant !== "ChangeLocaleStr") {
    return {
            formaters: state.formaters,
            labels: action.VAL,
            locale: state.locale,
            myArteUrl: state.myArteUrl,
            loginUrl: state.loginUrl,
            profileUrl: state.profileUrl
          };
  }
  var language = action.VAL;
  return {
          formaters: state.formaters,
          labels: state.labels,
          locale: Util_I18n.localeFromLanguage(language),
          myArteUrl: myArteUrlWithLocale(myArteBaseUrl, language),
          loginUrl: state.loginUrl,
          profileUrl: state.profileUrl
        };
}

function Provider_I18n(Props) {
  var locale = Props.locale;
  var labels = Props.labels;
  var formaters = Props.formaters;
  var myArteBaseUrlOpt = Props.myArteBaseUrl;
  var loginUrlOpt = Props.loginUrl;
  var profileUrlOpt = Props.profileUrl;
  var children = Props.children;
  var myArteBaseUrl = myArteBaseUrlOpt !== undefined ? myArteBaseUrlOpt : "https://my.arte.tv";
  var loginUrl = loginUrlOpt !== undefined ? loginUrlOpt : "https://my.arte.tv/index.php?lang=fr#section/landing";
  var profileUrl = profileUrlOpt !== undefined ? profileUrlOpt : "https://www.arte.tv/fr/profile";
  var ensuredLocale = React.useMemo((function () {
          return Util_I18n.localeFromLanguage(locale);
        }), [locale]);
  var ensuredFormaters = React.useMemo((function () {
          return Context_I18n.ensureFormaters(formaters);
        }), [formaters]);
  var myArteUrl = myArteUrlWithLocale(myArteBaseUrl, locale);
  var match = React.useReducer((function (param, param$1) {
          return reducer(myArteBaseUrl, param, param$1);
        }), initialState(ensuredLocale, labels, ensuredFormaters, myArteUrl, loginUrl, profileUrl));
  var dispatch = match[1];
  var state = match[0];
  React.useEffect((function () {
          Curry._1(dispatch, {
                NAME: "ChangeLocaleStr",
                VAL: locale
              });
          Curry._1(dispatch, {
                NAME: "ChangeLabels",
                VAL: labels
              });
        }), [locale]);
  var state$1 = React.useMemo((function () {
          return Context.I18n.make(/* Initialized */0, state);
        }), [state]);
  return React.createElement(Context.I18n.Provider.make, {
              value: [
                state$1,
                dispatch
              ],
              children: children
            });
}

var make = Provider_I18n;

exports.initialState = initialState;
exports.myArteUrlWithLocale = myArteUrlWithLocale;
exports.reducer = reducer;
exports.make = make;
/* react Not a pure module */
